"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY_TYPE_API = exports.CUSTOMER_SUBSCRIPTION_BUSINESS = exports.CUSTOMER_NOTIFICATIONS_API = exports.CUSTOMER_NOTIFICATIONS = exports.CUSTOMER_CACHE = exports.CUSTOMER_NOTES = exports.CUSTOMER_LIST_ADAPTER = exports.CUSTOMER_LIST = exports.CUSTOMER = exports.MEASUREMENTS_API = exports.RESULTS = exports.CALORIE_BUDGET_UTILS = exports.NUTRITION_CACHE = exports.NUTRITION_UTILS = exports.NUTRITION = exports.NUTRITION_API = exports.NUTRITION_FOOD_PREFERENCE = exports.NUTRITION_CALORIE_BUDGET = exports.TRAINING_API = exports.TRAINING = exports.TIMER = exports.EVENT_BUS = exports.DATE_TIME_BRIDGE = exports.SYSTEM_DATE_TIME_MODIFIER = exports.DATE_TIME_MODIFIER = exports.SYSTEM_DATE_TIME_PROVIDER = exports.DATE_TIME_PROVIDER = exports.LOGGER_API = exports.FETCH = exports.GRAPHQL_CLIENT = exports.HTTP_CLIENT = exports.JOURNAL_CACHE = exports.RECOVERY_CACHE = exports.TRAINING_CACHE = exports.BEHAVIOUR_CACHE = exports.NETWORK_FIRST_COMPOSITE_STRATEGY = exports.SYSTEM_DATE_TIME_CONFIG = exports.USER_DATE_TIME_CONFIG = exports.CONDITIONAL_CACHE_STRATEGY = exports.TIMER_STRATEGY = exports.NETWORK_FIRST_STRATEGY = exports.CACHE_STRATEGY = exports.LOGGER_CACHE = exports.CACHE = exports.IS_LOGGER_ENABLED = exports.CONFIG_LANGUAGE = exports.CONFIG_UNIT = exports.CONFIG_LOCALE = exports.CONFIG_ENVIRONMENT = exports.CONFIG_HOST = void 0;
exports.SPORT_ACTIVITY_ADAPTER = exports.SPORT_ACTIVITY = exports.SPORT_ACTIVITY_CACHE = exports.SPORT_ACTIVITY_API = exports.HISTORY = exports.HISTORY_API = exports.TRAINEE_LIST = exports.TRAINEE_LIST_API = exports.JOURNAL_API = exports.JOURNAL_ADAPTER = exports.JOURNAL = exports.RECOVERY_API = exports.RECOVERY_ADAPTER = exports.RECOVERY = exports.LOGGER_APP = exports.NETWORK_SUBSCRIPTION = exports.BEHAVIOUR = exports.BEHAVIOUR_ADAPTER = exports.BEHAVIOUR_API = exports.FETCH_RANGE_HELPERS = exports.SUBSCRIPTION_PICKER = exports.IDENTITY_SERVICE = exports.TOKEN_SERVICE = exports.AUTH_API = exports.AUTH_CACHE = exports.AUTH = exports.MESSAGE_SENT_LISTENER = exports.MESSAGE_MAKER = exports.CHAT_CACHE = exports.CHAT_PROCESSOR = exports.CHAT_QUEUE = exports.PBP_CHAT_API = exports.PMP_CHAT_API = exports.PMP_CHAT = exports.CHAT = exports.COACH_MONTHLY_MEMBERS_OVERVIEW = exports.COACH_USER = exports.COACH_RATING_LIST = exports.COACH_CAPACITY = exports.COACH = void 0;
// Config
exports.CONFIG_HOST = "CONFIG_HOST";
exports.CONFIG_ENVIRONMENT = "CONFIG_ENVIRONMENT";
exports.CONFIG_LOCALE = "CONFIG_LOCALE";
exports.CONFIG_UNIT = "CONFIG_UNIT";
exports.CONFIG_LANGUAGE = "CONFIG_LANGUAGE";
exports.IS_LOGGER_ENABLED = "IS_LOGGER_ENABLED";
// Cache
exports.CACHE = "CACHE";
exports.LOGGER_CACHE = "LOGGER_CACHE";
exports.CACHE_STRATEGY = "CACHE_STRATEGY";
exports.NETWORK_FIRST_STRATEGY = "NETWORK_FIRST_STRATEGY";
exports.TIMER_STRATEGY = "TIMER_STRATEGY";
exports.CONDITIONAL_CACHE_STRATEGY = "CONDITIONAL_CACHE_STRATEGY";
exports.USER_DATE_TIME_CONFIG = "USER_DATE_TIME_CONFIG";
exports.SYSTEM_DATE_TIME_CONFIG = "SYSTEM_DATE_TIME_CONFIG";
exports.NETWORK_FIRST_COMPOSITE_STRATEGY = "NETWORK_FIRST_COMPOSITE_STRATEGY";
exports.BEHAVIOUR_CACHE = "BEHAVIOUR_CACHE";
exports.TRAINING_CACHE = "TRAINING_CACHE";
exports.RECOVERY_CACHE = "RECOVERY_CACHE";
exports.JOURNAL_CACHE = "JOURNAL_CACHE";
// Http
exports.HTTP_CLIENT = "HTTP_CLIENT";
exports.GRAPHQL_CLIENT = "GRAPHQL_CLIENT";
exports.FETCH = "FETCH";
// Api
exports.LOGGER_API = "LOGGER_API";
// Utility
exports.DATE_TIME_PROVIDER = "DATE_TIME_PROVIDER";
exports.SYSTEM_DATE_TIME_PROVIDER = "SYSTEM_DATE_TIME_PROVIDER";
exports.DATE_TIME_MODIFIER = "DATE_TIME_MODIFIER";
exports.SYSTEM_DATE_TIME_MODIFIER = "SYSTEM_DATE_TIME_MODIFIER";
exports.DATE_TIME_BRIDGE = "DATE_TIME_BRIDGE";
exports.EVENT_BUS = "EVENT_BUS";
exports.TIMER = "TIMER";
// Training
exports.TRAINING = "TRAINING";
exports.TRAINING_API = "TRAINING_API";
// Nutrition
exports.NUTRITION_CALORIE_BUDGET = "NUTRITION_CALORIE_BUDGET";
exports.NUTRITION_FOOD_PREFERENCE = "NUTRITION_FOOD_PREFERENCE";
exports.NUTRITION_API = "NUTRITION_API";
exports.NUTRITION = "NUTRITION";
exports.NUTRITION_UTILS = "NUTRITION_UTILS";
exports.NUTRITION_CACHE = "NUTRITION_CACHE";
exports.CALORIE_BUDGET_UTILS = "CALORIE_BUDGET_UTILS";
// Results
exports.RESULTS = "RESULTS";
exports.MEASUREMENTS_API = "MEASUREMENTS_API";
// Customer
exports.CUSTOMER = "CUSTOMER";
exports.CUSTOMER_LIST = "CUSTOMER_LIST";
exports.CUSTOMER_LIST_ADAPTER = "CUSTOMER_LIST_ADAPTER";
exports.CUSTOMER_NOTES = "CUSTOMER_NOTES";
exports.CUSTOMER_CACHE = "CUSTOMER_CACHE";
exports.CUSTOMER_NOTIFICATIONS = "CUSTOMER_NOTIFICATIONS";
exports.CUSTOMER_NOTIFICATIONS_API = "CUSTOMER_NOTIFICATIONS_API";
exports.CUSTOMER_SUBSCRIPTION_BUSINESS = "CUSTOMER_SUBSCRIPTION_BUSINESS";
exports.DAY_TYPE_API = "DAY_TYPE_API";
// Coach
exports.COACH = "COACH";
exports.COACH_CAPACITY = "COACH_CAPACITY";
exports.COACH_RATING_LIST = "COACH_RATING_LIST";
exports.COACH_USER = "COACH_USER";
exports.COACH_MONTHLY_MEMBERS_OVERVIEW = "COACH_MONTHLY_MEMBERS_OVERVIEW";
// Chat
exports.CHAT = "CHAT";
exports.PMP_CHAT = "PMP_CHAT";
exports.PMP_CHAT_API = "PMP_CHAT_API";
exports.PBP_CHAT_API = "PBP_CHAT_API";
exports.CHAT_QUEUE = "CHAT_QUEUE";
exports.CHAT_PROCESSOR = "CHAT_PROCESSOR";
exports.CHAT_CACHE = "CHAT_CACHE";
exports.MESSAGE_MAKER = "MESSAGE_MAKER";
exports.MESSAGE_SENT_LISTENER = "MESSAGE_SENT_LISTENER";
// Auth
exports.AUTH = "AUTH";
exports.AUTH_CACHE = "AUTH_CACHE";
exports.AUTH_API = "AUTH_API";
exports.TOKEN_SERVICE = "TOKEN_SERVICE";
exports.IDENTITY_SERVICE = "IDENTITY_SERVICE";
// PBP10
exports.SUBSCRIPTION_PICKER = "SUBSCRIPTION_PICKER";
exports.FETCH_RANGE_HELPERS = "FETCH_RANGE_HELPERS";
// BEHAVIOUR
exports.BEHAVIOUR_API = "BEHAVIOUR_API";
exports.BEHAVIOUR_ADAPTER = "BEHAVIOUR_ADAPTER";
exports.BEHAVIOUR = "BEHAVIOUR";
// System
exports.NETWORK_SUBSCRIPTION = "NETWORK_SUBSCRIPTION";
exports.LOGGER_APP = "LOGGER_APP";
// Recovery
exports.RECOVERY = "RECOVERY";
exports.RECOVERY_ADAPTER = "RECOVERY_ADAPTER";
exports.RECOVERY_API = "RECOVERY_API";
// Journal
exports.JOURNAL = "JOURNAL";
exports.JOURNAL_ADAPTER = "JOURNAL_ADAPTER";
exports.JOURNAL_API = "JOURNAL_API";
// Trainee List
exports.TRAINEE_LIST_API = "TRAINEE_LIST_API";
exports.TRAINEE_LIST = "TRAINEE_LIST";
// History
exports.HISTORY_API = "HISTORY_API";
exports.HISTORY = "HISTORY";
// Sport activities
exports.SPORT_ACTIVITY_API = "SPORT_ACTIVITY_API";
exports.SPORT_ACTIVITY_CACHE = "SPORT_ACTIVITY_CACHE";
exports.SPORT_ACTIVITY = "SPORT_ACTIVITY";
exports.SPORT_ACTIVITY_ADAPTER = "SPORT_ACTIVITY_ADAPTER";
//# sourceMappingURL=config.consts.js.map